<template>
	<div v-loading="loading" class=" min_he400 magtop60">
		<div v-html="about.company_intr"></div>
		<p class="about_title">我们的服务宗旨</p>
		<div v-html="about.company_purpose"></div>
		<p class="about_title">我们的发展目标</p>
		<div v-html="about.company_target"></div>
		<p class="about_title">我们的企业理想</p>
		<div v-html="about.company_idea"></div>
		<p class="about_title">我们的行动方针</p>
		<div v-html="about.company_policy"></div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			loading:true,
			about:{}
		}
	},
	created(){
		this.Postcomposer()
	},
	methods:{
		async Postcomposer(){
			this.loading = true;
			let {data} = await this.api.Postcomposer();
			this.about = data;
			this.loading = false;
		}
	}
}
</script>

<style lang="scss" scoped>
.about_title{
	font-size: 18px;
	font-weight: 600;
	margin: 20px 0;
}
</style>
